import { defineComponent as _defineComponent } from 'vue'
import store from '@/store';
import oauthClient from '@/oauth';
import { computed, ref, watchEffect } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginMenu',
  setup(__props) {

const menu = ref(false);
const location = ref('');

const userInfo = computed(() => store.state.userInfo);
const userInitials = computed(() => (userInfo.value !== null ? `${userInfo.value.first_name[0] || ''}${userInfo.value.last_name[0] || ''}` : ''));

watchEffect(() => {
  if (menu.value) {
    location.value = window.location.href;
  }
});

async function logout() {
  // Perform the logout action,
  await store.dispatch.logout();

  // Redirect the user to the home page.
  // This is to prevent the logged-out user from continuing to look at, e.g.,
  // workspaces or tables they may have been viewing at the time of logout.
  window.location.href = 'https://multinet.app';
}

function login(): void {
  oauthClient.redirectToLogin();
}

// Get user info on created
store.dispatch.fetchUserInfo();

return { __sfc: true,menu, location, userInfo, userInitials, logout, login }
}

})